import React from "../../__compat__/react/main.entry.mjs.mjs";
import { GenericNavigationList } from "../GenericNavigation/index.mjs.mjs";
import { NavigationItem } from "./NavigationItem.mjs.mjs";
export const NavigationBar = React.forwardRef((props, ref) => (React.createElement(GenericNavigationList, { ...props, ref: ref, variant: "text", itemType: NavigationItem, "aria-label": props['aria-label'] })));
NavigationBar.displayName = 'NavigationBar';
//# sourceMappingURL=NavigationBar.mjs.mjs.map